<template>
  <div class="studio-container users-com">
    <div class="admin-header-sec">
      <h1 class="admin-title-sec">{{ $t('users') }}</h1>
      <div class="search-add-sec">
        <div class="text">{{ $t('search-by') + ':' }}</div>
        <select v-model="searchBy">
          <option value="name">{{ $t('name') }}</option>
          <option value="email">{{ $t('email') }}</option>
          <option value="studio">{{ $t('studio') }}</option>
        </select>
        <input v-if="searchBy == 'name'" type="text" :placeholder="$t('first-name')" v-model="firstName" />
        <input v-if="searchBy == 'name'" type="text" :placeholder="$t('last-name')" v-model="lastName" />
        <input v-if="searchBy == 'email'" type="text" :placeholder="$t('email')" v-model="email" />
        <div v-if="searchBy == 'studio'">
          <input type="text" @input="openSelectDropdown" @click="openSelectDropdown" v-model="studioFilter"
            :placeholder="$t('placeholder1')" />
          <div v-show="isDropdownOpen" class="dropdown-container">
            <div class="dropdown-options">
              <div v-for="studio in studios" :key="studio.id" @click="selectAnItem(studio)" class="dropdown-option">
                {{ studio.displayName }}
              </div>
            </div>
          </div>
        </div>
        <!-- <span @click.stop.prevent="handleButtonClick()" v-if="admin"> Add </span> -->
        <span class="fit20-btn save-btn-active" v-if="admin" @click="search">{{ $t('search') }}</span>
        <img width="50" @click.stop.prevent="handleButtonClick()" v-if="admin"
          :src="fit20.storageBaseUrl + '/static/icons/%2B.png'" />
      </div>
    </div>
    <div class="result-div" v-if="admin_fit20.users.length > 0">
      <input type="text" :placeholder="$t('search')" @input="filterUsers" />
      <div class="studios" id='admin_trainers_sec'>
        <div class="studio-card" v-for="user in filteredUsers" :key="user.id"
          @click.stop.prevent="handleButtonClick(user.id)">
          <a :href="admin ? '#admin_' : '#users'" :id="user.id">
            <div class="flex card-div">
              <img v-if="user.photo" :src="fit20.storageBaseUrl + '/user/' + user.id + '.png?generation=' + user.photo"
                height="auto" />
              <img v-if="!user.photo" :src="fit20.storageBaseUrl + '/member/default.svg'" height="auto" />
              <p class="item-name">{{ user.displayFirstName + " " + user.displayLastName }}</p>
            </div>
            <div class="right-bottom">
              <img :src="getLinkStatus(user.active)" />
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Users',
  components: {},
  props: ["fit20", "admin", "selectTab", "admin_fit20", "formatDate"],
  data() {
    return {
      isDropdownOpen: false,
      filteredUsers: [],
      inputValue: '',
      studioFilter: '',
      searchBy: 'name',
      firstName: '',
      lastName: "",
      email: "",
      studios: "",
      isFilter: false,
      originalStudios: [],
    };
  },
  computed: {

  },
  methods: {
    async search() {
      console.log("search");
      this.fit20.isLoaded = false;
      let filter;
      let searchBy;
      if (this.searchBy == 'name' && this.firstName && this.lastName) {
        filter = this.firstName.trim() + "--" + this.lastName.trim();
        searchBy = 'name';
      } else if (this.searchBy == 'name' && this.firstName) {
        filter = this.firstName.trim()
        searchBy = 'firstName';
      } else if (this.searchBy == 'name' && this.lastName) {
        filter = this.lastName.trim()
        searchBy = 'lastName';
      } else if (this.searchBy == 'email') {
        filter = this.email.trim()
        searchBy = 'email';
      } else {
        filter = this.studio.trim()
        searchBy = 'studio';
        if (filter.length < 1) {
          alert('empty-search');
        }
      }
      // console.log(filter);
      // console.log(this.searchBy);
      const getUsers = await fetch(this.fit20.baseUrl + "/api/users/filter/" + searchBy + "/" + filter + "?accessToken=" + localStorage.getItem('access_token') + "&user=" + this.fit20.user.email);

      this.admin_fit20.users = await getUsers.json();
      if (this.admin_fit20.users.msg) {
        // console.log(this.admin_fit20.members.msg);
        // alert("get-members-err");
        this.admin_fit20.users = [];
      }
      if (this.admin_fit20.users.length == 0) {
        alert('no-users-found');
      }

      // console.log(this.admin_fit20.members);
      this.fit20.isLoaded = true;
    },
    openSelectDropdown() {
      // console.log('open dropdown');
      // console.log(this.studios);
      // console.log(this.admin_fit20.studios);
      this.isDropdownOpen = true;
    },
    selectAnItem(item) {
      this.studioFilter = item.name;
      this.selectedItem = item;
      this.studio = item.id;
      this.isDropdownOpen = false;
    },
    async editUser(id) {
      console.log("edit user....");
      const res = await fetch(this.fit20.baseUrl + "/api/users/one/" + id + "?accessToken=" + localStorage.getItem('access_token') + "&user=" + this.fit20.user.email);
      this.admin_fit20.user = await res.json();
    },
    getStudio(e) {

    },
    async handleButtonClick(id) {
      if (this.admin) {
        if (id) {
          await this.editUser(id);
        } else {
          this.admin_fit20.user = {
            id: "new_user",
            displayFirstName: "",
            displayLastName: "",
            firstName: "",
            lastName: "",
            studios: [],
            language: '',
          }
        }
        this.selectTab('#admin_user');
      } else {
        await this.getUser(id);

        this.selectTab('#admin_users');
      }

    },
    filterUsers(event) {
      // this.inputValue = event;
      let searchWord = event.target.value.toLowerCase().trim()
      if (searchWord.length > 0) {
        this.filteredUsers =
          this.admin_fit20.users.filter(user => user.firstName.includes(searchWord) ||
            user.lastName.includes(searchWord));
      } else {
        this.filteredUsers = [...this.admin_fit20.users]
      }

    },
    getLinkStatus(status) {
      let link;
      if (status) {
        link = this.fit20.storageBaseUrl + "/user/active-trainer.png";
      } else {
        link = this.fit20.storageBaseUrl + "/user/inactive-trainer.png";
      }
      return link;
    }
  },
  mounted: function () {
    $('#admin_trainers_sec').scrollTop(0);
    console.log("scroll members");
  },
  created: function () { },
  watch: {
    'admin_fit20.users': {
      immediate: true, // This runs the watcher immediately on mount
      deep: true, // Watch for changes in nested properties
      handler(newVal) {

        this.filteredUsers = [...newVal];
      }
    },
    'fit20.studios': {
      immediate: true, // This runs the watcher immediately on mount
      deep: true, // Watch for changes in nested properties
      handler(newVal) {

        this.studios = [...newVal];
        this.originalStudios = [...newVal];
      }
    },
    studioFilter: {
      deep: true, // Watch for changes in nested properties
      handler(newVal) {
        if (newVal.length > 0) {
          this.studios = [...this.originalStudios].filter(studio => (studio.name).includes(newVal.toLowerCase().trim()));
          this.isFilter = true;
        } else if (this.isFilter) {
          this.studios = [...this.originalStudios];
          this.isFilter = false;
        }
      }
    },
    'fit20.selectedTabHref': {
      immediate: true, // This runs the watcher immediately on mount
      deep: true, // Watch for changes in nested properties
      handler(newVal) {

        if (newVal == '#admin_members') {
          $('#admin_trainers_sec').scrollTop(0);
        }
      }
    }
  }
};
</script>

<style>
.users-com .text {
  padding: 10px 0;
}

.users-com select,
.users-com input {
  background: white;
  border: solid 1px var(--fit20-lighter-gray);
  border-radius: 10px;
  width: 20% !important;
  padding-left: 5px;
}

.users-com .search-add-sec div input {
  width: 100% !important;
}

.users-com .save-btn-active {
  padding: 10px 20px !important;
}

.users-com.studio-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.users-com .result-div {
  position: absolute;
  /* top: 0;
  left: 0; */
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.users-com .search-add-sec {
  display: flex;
  justify-content: space-between;
}

.users-com .search-add-sec img {
  width: 50px;
  min-width: 0px;
  min-height: 0px;
}

.users-com .studio-container input {
  border: solid 1px var(--fit20-lighter-gray);
  border-radius: 10px;
  padding: 7px 5px;
  width: 40%;
}

.users-com .right-bottom {
  position: absolute;
  width: 20%;
  bottom: -7px;
  right: 5px;
}

.users-com .right-bottom img {
  width: 100%;
}
</style>
